export const SGA_LOGIN_TRANSACTION_PREFIX = "sga-login-transaction";
export const SGA_VERIFICATION_TRANSACTION_PREFIX = "sga-verification-transaction";
